import React from 'react';
import { useDispatch } from 'react-redux';
import { Formik, Form, Field } from 'formik';
import { Link } from 'react-router-dom';
import axios from 'axios';
import SSOSigninSignUpForm from '../sso/SSOSigninSignUpForm';
import Input from '../signUp/Input';
import Button from '../../main/components/Button';
import { SignupUserOnlySchema } from '../signUp/validationSchema';
import { ALERT_TYPES } from '../../main/utils/const';
import * as Route from '../../main/utils/serverRoutes';

const stepsCount = 1;
const step = 1;

const prepareValues = (
  { firstName, surname, email, password },
  { establishmentId },
  role,
  slug,
) => {
  return {
    user: {
      firstName,
      surname,
      email,
      password,
    },
    elevatedPrivilege: {
      role,
      slug,
    },
    establishmentId,
  };
};

export const ElevatedPrivilegesSignup = ({ locales, data }) => {
  const { onboarding: pageLocales } = locales;
  const establishmentIsStandardAuthAllowed = JSON.parse(
    data.establishmentIsStandardAuthAllowed,
  );
  const establishmentIsSsoAuthAllowed = JSON.parse(
    data.establishmentIsSsoAuthAllowed,
  );
  const { role, slug } = data.elevatedSignupInfo;

  const {
    alert: { addAlert },
  } = useDispatch();

  return (
    <>
      {establishmentIsStandardAuthAllowed && (
        <>
          <p className="sign-up-form-section__step-counter">
            {pageLocales.common.step} {step} {pageLocales.common.of}{' '}
            {stepsCount}
          </p>
          <Formik
            initialValues={{}}
            validationSchema={SignupUserOnlySchema}
            onSubmit={(values) => {
              axios
                .post(
                  Route.signUpElevatedPrivilege(),
                  prepareValues(values, data, role, slug),
                )
                .then(() => {
                  window.location = `/`;
                })
                .catch((error) => {
                  if (error.response.status === 403) {
                    addAlert({
                      id: 403,
                      type: ALERT_TYPES.warning,
                      title: error.response.data.errors.join(' '),
                    });
                  } else if (error.response.status === 422) {
                    const errors = Object.values(
                      error.response.data.errors,
                    ).map((singleError) => singleError[0]);
                    addAlert({
                      id: 422,
                      type: ALERT_TYPES.warning,
                      title: errors.join(' '),
                    });
                  }
                });
            }}
          >
            {({ errors, setFieldValue, submitForm }) => {
              const isDisabledCreateAccount = !(
                !errors.firstName &&
                !errors.surname &&
                !errors.email &&
                !errors.password
              );
              const completeForm = () => {
                setFieldValue('role', role);
                setFieldValue('slug', slug);
                submitForm();
              };

              return (
                <Form className="sign-up-form">
                  <h3 className="sign-up-form__title">
                    {pageLocales.titles.step1ElevatedPrivilege}
                  </h3>
                  <div className="sign-up-form__row">
                    <Field
                      locales={locales}
                      component={Input}
                      label={pageLocales.inputLabels.firstName}
                      placeholder={pageLocales.inputPlaceholders.name}
                      name="firstName"
                    />
                    <Field
                      locales={locales}
                      component={Input}
                      label={pageLocales.inputLabels.surname}
                      placeholder={pageLocales.inputPlaceholders.surname}
                      name="surname"
                    />
                  </div>
                  <Field
                    locales={locales}
                    name="email"
                    component={Input}
                    label={pageLocales.inputLabels.email}
                    placeholder={pageLocales.inputPlaceholders.email}
                    className="margin-bottom-20"
                  />
                  <Field
                    locales={locales}
                    name="password"
                    component={Input}
                    label={pageLocales.inputLabels.password}
                    placeholder={pageLocales.inputPlaceholders.password}
                    type="password"
                    className="margin-bottom-20"
                  />
                  <div className="sign-up-form__actions">
                    <Button
                      className="w-full"
                      variant="secondary"
                      onClick={() => completeForm()}
                      disabled={isDisabledCreateAccount}
                    >
                      {pageLocales.buttons.createAccount}
                    </Button>
                  </div>
                  <div className="sign-up-form__links">
                    {pageLocales.common.alreadyHaveAccount}
                    <Link to="/onboarding/sign_in">
                      {pageLocales.common.signIn}
                    </Link>
                  </div>
                </Form>
              );
            }}
          </Formik>
        </>
      )}
      {establishmentIsStandardAuthAllowed && establishmentIsSsoAuthAllowed && (
        <hr style={{ margin: '3rem 0', color: 'white' }} />
      )}
      {!establishmentIsStandardAuthAllowed && establishmentIsSsoAuthAllowed && (
        <h3 className="text-3xl text-white font-bold pt-12">
          {locales.onboarding.titles.step1ElevatedPrivilege}
        </h3>
      )}
      {establishmentIsSsoAuthAllowed && (
        <SSOSigninSignUpForm data={data} locales={pageLocales} />
      )}
    </>
  );
};
